export default "__VITE_ASSET__DdtoOXpB__"